import React from "react";
import AboutIcons from "../components/AboutIcons";
import Footer from "../components/Footer";
import Navbar from "../components/Navbar";
import FeaturedList from "../components/FeaturedList";

function Featured() {
  

  const navigation = [
    { name: "Home", href: "/", current: false },
    // { name: "About", href: "/about", current: false },
    { name: "Projects", href: "/projects", current: false },
    { name: "Work/Research", href: "/experience", current: false },
    {name: "Awards", href: "/awards", current: false},
    { name: "Featured", href: "/featured", current: true },
  ];
  return (
    <div className="lg:grid lg:h-fit lg:place-items-center">
      <div className="lg:w-3/4 bg-customGray outline-outlineGray outline md:pl-10 md:pr-10 lg:pl-10 lg:pr-10 ">
        <Navbar navigation={navigation} />
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-2 mt-10">
          <FeaturedList/>
          <AboutIcons/>
        </div>
        <Footer />
      </div>
      
    </div>
  );
}

export default Featured;
